import {
  ICreateCustomRuleRequestBody,
  ICreateCustomRuleResponse,
  IDeleteCustomRuleRequestFilters,
  IDeleteCustomRuleResponse,
  IGetCustomRuleRequestFilters,
  IGetCustomRulesResponse,
  IGetSingleCustomRuleResponse,
  IUpdateCustomRuleRequestBody,
  IUpdateCustomRuleResponse,
} from 'models/http/customRule';
import DataUploadBaseHttp from './utils/data-upload.http';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';
import { HTTP } from './core.http';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from 'utils/http';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { AxiosResponse } from 'axios';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';
import { CustomRuleType } from 'pages/Rules/CustomRules.model';

class CustomRuleHttp extends DataUploadBaseHttp implements HTTP<IDeleteCustomRuleRequestFilters> {
  protected readonly route: DataUploadModels = ModelsNames.CustomRules;

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async get(filter: IGetCustomRuleRequestFilters, abortController?: AbortController): Promise<IGetCustomRulesResponse> {
    const queryParams = prepareQPFromFilters(filter || {});

    return serverAxios
      .get(`/${this.route}?${queryParams.toString()}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetCustomRulesResponse>) => {
        return response.data;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleCustomRuleResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSingleCustomRuleResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateCustomRuleRequestBody): Promise<ICreateCustomRuleResponse> {
    return serverAxios
      .post(`/${this.route}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateCustomRuleResponse>) => {
        return response.data;
      });
  }

  public async update(id: number, data: IUpdateCustomRuleRequestBody): Promise<IUpdateCustomRuleResponse> {
    return serverAxios
      .put(`/${this.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IUpdateCustomRuleResponse>) => {
        return response.data;
      });
  }

  public async delete(ids: number[], type: CustomRuleType): Promise<IDeleteCustomRuleResponse>;
  public async delete(filters: IDeleteCustomRuleRequestFilters, type?: CustomRuleType): Promise<IDeleteCustomRuleResponse>;
  public async delete(filters: number[] | IDeleteCustomRuleRequestFilters, type: CustomRuleType): Promise<IDeleteCustomRuleResponse> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: { ...prepareFiltersOfSelection(filters), type },
      })
      .then((response: AxiosResponse<IDeleteCustomRuleResponse>) => {
        return response.data;
      });
  }
}

export default CustomRuleHttp;
